import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { emptyObject } from "constants/defaultValues";
import { GET_PARTNER_SEARCH_CONDITION_QUERY } from "../../../queries";
import { LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";
import ExtendedFilters from "./ExtendedFilters";
import BasicFilters from "./BasicFilters";
import { customClientFilters } from "constants/customClientFilters";
import { get } from "@totalsoft/react-state-lens";

function CustomFilters({ filterLens, onReset, onBasicSearch, onExtendedSearch, loadingList }) {
  const [condition, setCondition] = useState(emptyObject);

  const [extended, setExtended] = useState(false);

  const { loading } = useQueryWithErrorHandling(GET_PARTNER_SEARCH_CONDITION_QUERY, {
    onCompleted: (data) => {
      setCondition(data.getPartnerSearchCondition);
    },
  });

  const getFilterProperty = useCallback((propCode, filterObj) => {
    switch (propCode) {
      case customClientFilters.companyName:
        return filterObj.companyName;
      case customClientFilters.taxId:
        return filterObj.taxId;
      case customClientFilters.zip:
        return filterObj.zip;
      case customClientFilters.street1:
        return filterObj.street1;
      case customClientFilters.state:
        return filterObj.state;
      case customClientFilters.city:
        return filterObj.city;
      case customClientFilters.legalForm:
        return filterObj.legalFormName;
      case customClientFilters.registrationNumber:
        return filterObj.registrationNumber;
      default:
        return null;
    }
  }, []);

  const handleExtended = useCallback(() => {
    setExtended((prev) => !prev);
  }, [setExtended]);

  const handleExtendedSearch = useCallback(() => {
    onExtendedSearch(true);
  }, [onExtendedSearch]);

  const handleSearch = useCallback(() => {
    const paramValues = condition?.paramValues
      ?.filter((x) => condition.searchConditionText.indexOf(x.translatedName) !== -1)
      ?.map(({ translatedName: _, ...rest }) => ({
        ...rest,
        value: getFilterProperty(rest.code, filterLens) |> get,
      }));
    onBasicSearch(paramValues);
  }, [condition, filterLens, onBasicSearch, getFilterProperty]);

  if (loading) {
    return <LoadingFakeText lines={10} />;
  }

  return extended ? (
    <ExtendedFilters
      loading={loadingList}
      condition={condition}
      filterLens={filterLens}
      getFilterProperty={getFilterProperty}
      onReset={onReset}
      onSearch={handleExtendedSearch}
      onExtended={handleExtended}
    />
  ) : (
    <BasicFilters
      loading={loadingList}
      condition={condition}
      filterLens={filterLens}
      getFilterProperty={getFilterProperty}
      onReset={onReset}
      onSearch={handleSearch}
      onExtended={handleExtended}
    />
  );
}

CustomFilters.propTypes = {
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onBasicSearch: PropTypes.func.isRequired,
  onExtendedSearch: PropTypes.func.isRequired,
  loadingList: PropTypes.bool.isRequired,
};

export default CustomFilters;
